import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule as MercuryButtonModule } from '@shipmercury/mercury-ui';

import { Drawer } from 'primeng/drawer';

@Component({
  selector: 'au-public-header',
  templateUrl: './public-header.component.html',
  styleUrls: ['./public-header.component.scss'],
  imports: [MercuryButtonModule, Drawer],
})
export class PublicHeaderComponent {
  mercuryLogoPath: string = '../../assets/images/mercury-logo-reversed.svg';
  mercuryLogoBluePath: string = '../../assets/images/logo-original.svg';
  isSideBarVisible: boolean = false;
  hideButtons: boolean = false;

  constructor(private router: Router) {
    if (this.router.url.includes('ship-lite')) {
      this.hideButtons = true;
    }
  }

  navigateToRequestDemo(): void {
    this.router.navigateByUrl('ship-lite');
  }

  navigateToLogin(): void {
    this.router.navigateByUrl('login');
  }

  openSidebar(): void {
    this.isSideBarVisible = true;
  }
}
